import { useState, useEffect } from 'react';
import { IUserProfile, UserProfileSystem } from '../../system/perfiles/UserProfileSystem';

export default function useUserProfiles(system: UserProfileSystem) {
  const [profiles, setProfiles] = useState<IUserProfile[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfiles = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await system.getUserProfiles();
        setProfiles(data);
      } catch (err: any) {
        setError(err.message || 'Error al obtener perfiles');
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, []);

  return { profiles, loading, error };
}
